import { render, staticRenderFns } from "./BrandInfo.vue?vue&type=template&id=0ef2ffde&scoped=true&"
import script from "./BrandInfo.vue?vue&type=script&lang=js&"
export * from "./BrandInfo.vue?vue&type=script&lang=js&"
import style0 from "./BrandInfo.vue?vue&type=style&index=0&id=0ef2ffde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef2ffde",
  null
  
)

export default component.exports